import React from 'react';


function TodosError() {
  
  return (
    <p>Lo siento, tienes un error!</p>
  );
}

export { TodosError };